import { z } from 'zod';

import {
  PrintStatusSchema,
  PurchaseCancellationSchema,
  PurchaseCommittedSnapshotSchema,
  PurchaseHistoryItemSchema,
} from './purchases.schema.js';
import type {
  GetPurchaseHistoryRequest,
  GetPurchaseHistoryResponse,
  ListPurchaseHistoryRequest,
  ListPurchaseHistoryResponse,
} from './purchases-history.dto.js';
import { purchaseHistoryCancellationStateValues } from './purchases-history.dto.js';
import { purchasePrintStatusValues } from './purchases.dto.js';

export const ListPurchaseHistoryRequestSchema: z.ZodType<ListPurchaseHistoryRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).max(200).optional(),
  search: z.string().trim().min(2).max(64).optional(),
  cancellationState: z.enum(purchaseHistoryCancellationStateValues).optional(),
  printStatus: z.enum(purchasePrintStatusValues).optional(),
  operatorUserId: z.uuid().optional(),
});

export const ListPurchaseHistoryResponseSchema: z.ZodType<ListPurchaseHistoryResponse> = z.object({
  // PurchaseHistoryItemSchema carries optional cancellationSummary for list-card visibility.
  items: z.array(PurchaseHistoryItemSchema),
  page: z.number().int().min(1),
  pageSize: z.number().int().min(1).max(200),
  hasMore: z.boolean(),
  total: z.number().int().min(0).optional(),
});

export const GetPurchaseHistoryRequestSchema: z.ZodType<GetPurchaseHistoryRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  purchaseId: z.uuid(),
});

export const GetPurchaseHistoryResponseSchema: z.ZodType<GetPurchaseHistoryResponse> = z.object({
  purchase: PurchaseCommittedSnapshotSchema,
  printStatus: PrintStatusSchema,
  cancellation: PurchaseCancellationSchema.nullable(),
});
